const ws_scheme = window.location.protocol == "https:" ? "wss" : "ws";
const host = window.location.hostname;
const port = window.location.protocol == "https:" ? "" : ":8000";

const HOST_URL = `http://${host}${port}`;
const SOCKET_URL = `${ws_scheme}://${host}${port}`;

export { HOST_URL, SOCKET_URL };